import React from "react";
import { useFormContext } from "react-hook-form";
import Input from "Components/UI/Input";
import { Controller } from "react-hook-form";
import Select from "react-select";
import { useGetEmployeeQuery } from "AppQuries/employee/employee_list";
import { useGetAllDepartmentQuery } from "AppQuries/master/Department/get-all-departments";
import { useGetDeductionsQuery } from "AppQuries/payroll/deduction/get-all-deduction";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import PropTypes from "prop-types";
const isStatusOption = [
  { id: 1, label: "Yes", value: true },
  { id: 0, label: "No", value: false },
];

const EmpDeductionForm = ({mode}) => {
  const userData = useSelector(loggedInUser);
  const {
    control,
    register,
    watch,
    setValue,
    trigger,
    formState: { errors },
  } = useFormContext();
  const { data: employees } = useGetEmployeeQuery({
    companyCode: userData?.companyCode,
    locationCode: userData?.locationCode,
  });
  const { data: departments } = useGetAllDepartmentQuery({
    companyCode: userData?.companyCode,
    isTrue: true,
  });
  const { data: deductions } = useGetDeductionsQuery({
    companyCode: userData?.companyCode,
  });
  const employeeOptions = Array.isArray(employees)
    ? employees
        .filter((d) => d.isActive)
        .map((o) => ({
          id: o.employeeCode,
          label: `${o.uniqueId}-${o.fullName}`,
          value: o.employeeCode,
        }))
    : [];

  const departmentOptions = Array.isArray(departments?.data)
    ? departments?.data
        .filter((d) => d.isActive)
        .map((o) => ({
          id: o.code,
          label: o.description,
          value: o.code,
        }))
    : [];

    console.log(departmentOptions)

  const deductionOptions = Array.isArray(deductions?.data)
    ? deductions?.data
        //   .filter((data) => data.isActive === true)
        .map((o) => ({
          id: o.code,
          label: o.description,
          value: o.code,
        }))
    : [];
  return (
    <div className="form-row row">
      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="departmentCode"
          type="commonSelect"
          placeholder=""
          className={`form-control select ${
            errors.departmentCode ? "is-invalid" : ""
          }`}
          label="Department"
          labelClassName="form-label"
          optionData={departmentOptions}
          required={true}
          requiredMessage="Department is required"
          onChange={(e) => {
            setValue("departmentCode", e);
          }}
          disabled={mode === "E" ? true : false}
          defaultValue={watch("departmentCode")}
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="employeeCode"
          type="commonSelect"
          placeholder=""
          className={`form-control select ${
            errors.employeeCode ? "is-invalid" : ""
          }`}
          label="Employee"
          labelClassName="form-label"
          optionData={employeeOptions}
          required={true}
          requiredMessage="Employee is required"
          onChange={(e) => {
            setValue("employeeCode", e);
          }}
          disabled={mode === "E" ? true : false}
          defaultValue={watch("employeeCode")}
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="code"
          type="commonSelect"
          placeholder=""
          className={`form-control select ${errors.code ? "is-invalid" : ""}`}
          label="Deduction Name"
          labelClassName="form-label"
          optionData={deductionOptions}
          required={true}
          requiredMessage="Employee is required"
          labelInValue
          onSelect={(e) => {
            setValue("code", e.value);
            setValue("description", e.label);
            trigger("code");
            trigger("description");
          }}
          value={deductionOptions.find(
            (option) => option.value === watch("code")
          )}
          // defaultValue={watch("employeeCode")}
          disabled={mode === "E" ? true : false}
        />
        
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="amount"
          type="text"
          placeholder="Amount"
          className={`form-control ${errors.amount ? "is-invalid" : ""}`}
          label="Amount"
          labelClassName="form-label"
          required={true}
          requiredMessage="Amount is required"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="haveCPF"
          type="commonSelect"
          placeholder=""
          className={`form-control select ${
            errors.haveCPF ? "is-invalid" : ""
          }`}
          label="Have CPF"
          labelClassName="form-label"
          optionData={isStatusOption}
          required={true}
          requiredMessage="Have CPF is required"
          onChange={(selectedOption) => {
            setValue("haveCPF", selectedOption);
            trigger("haveCPF");
          }}
          defaultValue={watch("haveCPF")}
        />
      </div>

      {/* <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="isTaxPayable"
          type="commonSelect"
          placeholder=""
          className={`form-control select ${
            errors.isTaxPayable ? "is-invalid" : ""
          }`}
          label="Tax Payable"
          labelClassName="form-label"
          optionData={isStatusOption}
          required={true}
          requiredMessage="Tax Payable is required"
          onChange={(selectedOption) => {
            setValue("isTaxPayable", selectedOption);
            trigger("isTaxPayable");
          }}
          defaultValue={watch("isTaxPayable")}
        />
      </div> */}

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="effectiveDateFrom"
          type="date"
          placeholder=""
          className={`form-control ${
            errors.effectiveDateFrom ? "is-invalid" : ""
          }`}
          label="Effective From"
          labelClassName="form-label"
          required={false}
          requiredMessage="Effective From is required"
          dateFormat="YYYY-MM-DD"
          disabledDate={(current) => {
            return current < dayjs().subtract(1, "day").endOf("day");
          }}
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="effectiveDateTo"
          type="date"
          placeholder=""
          className={`form-control ${
            errors.effectiveDateTo ? "is-invalid" : ""
          }`}
          label="Effective To"
          labelClassName="form-label"
          required={false}
          requiredMessage="Effective To is required"
          dateFormat="YYYY-MM-DD"
          disabledDate={(current) => {
            const effectiveDateFrom = dayjs(watch("effectiveDateFrom"));
            return (
              current < dayjs().subtract(1, "day").endOf("day") ||
              current < effectiveDateFrom
            );
          }}
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="isActive"
          type="commonSelect"
          placeholder=""
          className={`form-control select ${
            errors.isActive ? "is-invalid" : ""
          }`}
          label="Status"
          labelClassName="form-label"
          optionData={isStatusOption}
          required={true}
          requiredMessage="Status is required"
          onChange={(selectedOption) => {
            setValue("isActive", selectedOption);
            trigger("isActive");
          }}
          defaultValue={watch("isActive")}
        />
      </div>
    </div>
  );
};

EmpDeductionForm.propTypes = {
  mode : PropTypes.string.isRequired
}

export default EmpDeductionForm;
